import { useRef, useState } from "react";
import { TooltipContainer } from "./Tooltip.styles";
import TooltipElement from "./TooltipElement";

type TooltipProps = {
  children: React.ReactNode;
  tooltipContent: string | React.ReactNode;
  disableTooltip?: boolean;
  maxWidth?: number;
  minDistance?: number;
};

export default function Tooltip({
  children,
  tooltipContent,
  disableTooltip,
  maxWidth = 360,
  minDistance = 50,
}: TooltipProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerBounds, setContainerBounds] = useState<DOMRect | null>(null);
  const unsetContainerBounds = () => {
    setContainerBounds(null);
    document.removeEventListener("scroll", unsetContainerBounds);
  };
  const onMouseOverHandler = () => {
    if (!disableTooltip && containerRef.current) {
      setContainerBounds(containerRef.current.getBoundingClientRect());
      document.addEventListener("scroll", unsetContainerBounds);
    }
  };
  const onMouseLeaveHandler = unsetContainerBounds;

  return (
    <TooltipContainer
      ref={containerRef}
      onMouseOver={onMouseOverHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      {containerBounds && (
        <TooltipElement
          containerBounds={containerBounds}
          tooltipContent={tooltipContent}
          maxWidth={maxWidth}
          minDistance={minDistance}
        />
      )}
      {children}
    </TooltipContainer>
  );
}
